import { AppointmentTypeDto } from "./location.dtos";

export const isAvailableOnline = (t: AppointmentTypeDto) =>
  t.isAvailableNewPatients || t.isAvailableExistingPatients;
